<form [formGroup]="form" autocomplete="off" class="form-horizontal">
  <h2
    class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.NACHREICHUNG.TITEL' | translate }}
  </h2>

  <p
    class="mb-2x">{{ 'COMMON_UI.FRAGEBOGEN.NACHREICHUNG.UNTERTITEL' | translate }}
  </p>

  <div *ngFor="let formInput of formInputs" class="form-check">
    <div class="form-check">
      <input class="form-check-input" formControlName={{formInput.name}} id={{formInput.name}} type="checkbox"
             utilsControlState>
      <label class="form-check-label"
             for={{formInput.name}}>
        {{ formInput.label | translate }}
      </label>
    </div>
  </div>

  <div class="form-row mt-2x">
    <label class="col-sm-4 col-form-label"
           for="weitereUnterlagen">{{ 'COMMON_UI.FRAGEBOGEN.NACHREICHUNG.WEITEREUNTERLAGEN' | translate }}</label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="weitereUnterlagen{{objectId}}" formControlName="weitereUnterlagen"
             id="weitereUnterlagen"
             type="text" utilsCheckValidity
             utilsControlState utilsValidationMessage/>
    </div>
  </div>
</form>
